<mat-card appearance="outlined">
  <mat-card-content class="stepper-detail-card u-flex-column">
    <div>
      <button
        (click)="continue.emit(currentStep)"
        [class.form-invalid]="disableContinueBtn"
        class="button button-primary button-block flex middle center button__stepper-continue">
        <span class="button__label button__mobile-label">
          {{
            (currentStep !== serviceRequestStepType.Confirmation
              ? localizationConstants.BUTTON_CONTINUE
              : localizationConstants.BUTTON_BACK_TO_HOME
            ) | translate
          }}
        </span>
        <mat-icon
          [svgIcon]="currentStep !== serviceRequestStepType.Confirmation ? 'chevronRight' : 'home'"
          color="white"></mat-icon>
      </button>

      <div *ngIf="disableContinueBtn">
        <span class="c-form-alert">
          {{ localizationConstants.SERVICE_REQUEST_FORM_ERRORS | translate }}
        </span>
      </div>
    </div>

    <mat-divider></mat-divider>

    <button
      *ngIf="currentStep !== serviceRequestStepType.Confirmation"
      (click)="stepperClose.emit()"
      class="button button-secondary button-block">
      {{ localizationConstants.BUTTON_CANCEL | translate }}
    </button>

    <div class="c-section-title">
      {{ servicesSummaryEquipmentLength }}
      {{ localizationConstants.SERVICE_REQUEST_TOOLS | translate }}
    </div>

    <div class="services-summary">
      <div
        *ngFor="let serviceProp of servicesSummary | keyvalue"
        class="services-summary-service">
        <ul>
          <li
            *ngFor="let modelProp of serviceProp.value | keyvalue"
            class="services-summary-model">
            <span>{{ modelProp.key }}</span>
            <ul>
              <li
                *ngFor="let serialNumber of modelProp.value"
                class="services-summary-serial">
                <span>{{ serialNumber }}</span>
              </li>
            </ul>
          </li>
        </ul>
        <div class="flex end services-summary-service-name">
          {{ serviceProp.key }}
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
